module.exports = __webpack_public_path__ + "img/lucky5_icon.fddb1342.png";